import React from 'react'

// componets
import Prices from '@/components/organisms/Prices'
import { Footer } from '@/components/organisms/Footer/Footer'
import { Menu } from '@/components/organisms/Menu/Menu'
import { HomeProvider } from '@/context/guest/Home/HomeProvider'

// import { TermsCondProvider } from '@/context/guest/TermsCond/TermsCondProvider'

const Index = () => {
  return (
    <>
      <Menu />
      <HomeProvider>
        <Prices />
      </HomeProvider>
      <Footer />
    </>
  )
}

export default Index
